import { Product, productLink } from '@/mocks/products';

interface ProductCardProps {
  product: Product;
}

export default function ProductCard({ product }: ProductCardProps) {
  const link = productLink(product.id);

  return (
    <div className="bg-white rounded-lg border border-background-200 overflow-hidden hover:shadow-md transition-shadow duration-300 flex flex-col">
      <a href={link} target="_blank" rel="noopener nofollow" className="block overflow-hidden">
        <div className="aspect-square bg-background-100">
          <img
            src={product.image}
            alt={product.name}
            className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
        </div>
      </a>
      <div className="p-4 flex flex-col flex-1">
        <span className="inline-block self-start px-2 py-1 bg-secondary-100 text-secondary-800 text-xs font-medium rounded-full mb-2">
          {product.category}
        </span>
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 overflow-hidden min-h-[2.5rem] leading-snug">
          {product.name}
        </h3>
        <p className="text-base font-semibold text-primary-600 mt-2">
          {product.price}
        </p>
        <div className="mt-auto pt-3">
          <a
            href={link}
            target="_blank"
            rel="noopener nofollow"
            className="block w-full text-center py-2.5 bg-primary-500 text-white text-sm font-medium rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            Buy It Now
          </a>
        </div>
      </div>
    </div>
  );
}